import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
  OnDestroy,
  HostListener
} from '@angular/core';
import {Credentials} from 'src/app/core/models/credentials';
import {ActivatedRoute, Router} from '@angular/router';
import {BlockUI, NgBlockUI} from 'ng-block-ui';
import {AuthenticationService} from 'src/app/core/services/authentication.service';
import {first} from 'rxjs/operators';
import {Subscription} from 'rxjs';
import {NotificationService} from 'src/app/core/services/notification.service';
import {Message} from 'src/app/core/class/message';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {AuthService} from 'src/app/core/auth/auth.service';
import {LoginBase} from '../login-base';
import {MatDialog} from '@angular/material';
import {RecaptchaComponent} from 'ng-recaptcha';
import {TranslateService} from '@ngx-translate/core';
import {CommonService} from '../../../core/services/common.service';
import {AnonymousSignService} from '../../../core/services/anonymous-sign.service';
import {EnumContractStatus} from '../../../core/constants/contract';
import {HyperLink} from 'src/app/core/constants/hyperlink';
import {browser} from 'protractor';
import {WarningHasTokenComponent} from 'src/app/shared/components/warning-has-token/warning-has-token.component';
import {EnterpriseService} from 'src/app/core/services/enterprise.service';
import {ErrorCode} from 'src/app/core/constants/error-code';
import { DocumentService } from 'src/app/core/services/document.service';

declare function changeRecaptchaLanguage(language): any;

declare function resetRecaptchaValue(callback): any;

declare function resetRecaptchaStatus(language): any;


@Component({
  selector: 'app-anonymous-login',
  templateUrl: './anonymous-login.component.html',
  styleUrls: ['./anonymous-login.component.scss']
})

/*
 * <pre>
 * <b>Class name: LoginEnterpriseComponent</b>
 * <b>Explanation:</b> Component Login Enterprise
 * <b>Creation date:</b> 2019/08/25
 * </pre>
 *
 * @author GCS 2019/07/01 by linhdh
 **/
export class AnonymousLoginComponent extends LoginBase implements OnInit, AfterViewInit, OnDestroy {

  /**
   * the block ui.
   */
  @BlockUI() blockUI: NgBlockUI;
  public phoneNumber: string = '';
  currentLanguage = 'vi';

  signin = new FormGroup({
    email: new FormControl(null, Validators.required),
    password: new FormControl(null, Validators.required),
    captcha: new FormControl(),
  });
  loginForm: FormGroup;

  // Variables for showing re captcha
  failedLoginCount: any;
  limitFailedLoginNoReCaptcha = 4;
  showReCaptchaRequiredErr = false;

  credentials: Credentials = new Credentials('', false);
  errorMessage = '';
  isRemember: boolean;
  autoLogout = false;
  username: string;
  password: string;
  captcha: string;
  error = '';
  subscription: Subscription;
  invalidLogin = false;
  passwordVisibility = false;
  id = 1;
  isSignAnonymousWithCapCha = false;

  @ViewChild(RecaptchaComponent, {static: false})
  public reCaptcha: RecaptchaComponent;
  @Output() changeLanguage = new EventEmitter<boolean>();
  private hashKey: string;
  private tenantId: string;
  private contractIdAndContractEnterpriseIdEncode: string = null;
  isCheckAccessToContract = true;


  mode: string = 'LOGIN' || 'SEARCH_CLOUD_CA' || 'SIGN';
  dataLoginCaptcha: any;
  slideCaptcha : any;
  /**
   * <pre>
   * <b>Method name: constructor</b>
   * <b>Explanation: </b> Method constructor
   * </pre>
   * @author GCS 2019/08/25 by linhdh
   *
   */
  constructor(
    private router: Router,
    private authService: AuthenticationService,
    private authSer: AuthService,
    private notificationService: NotificationService,
    private dialogRef: MatDialog,
    private message: Message,
    private route: ActivatedRoute,
    private translate: TranslateService,
    public commonService: CommonService,
    private anonymousSignService: AnonymousSignService,
    private enterpriseService: EnterpriseService,
    private documentService: DocumentService,
    private el: ElementRef,
  ) {
    super();
    this.phoneNumber = HyperLink.PHONE_NUMBER;
  }

  /**
   * <pre>
   * <b>Method name: ngOnInit</b>
   * <b>Explanation: </b> Method initial
   * </pre>
   * @author GCS 2019/08/25 by linhdh
   *
   */
  ngOnInit() {
    this.mode = 'LOGIN';
    sessionStorage.clear();
    localStorage.removeItem('permissionContractShare')
    // get hashkey, tenantid
    this.route.paramMap.subscribe(params => {
      this.hashKey = params.get('hashKey');
      this.tenantId = params.get('tenantId');
      this.contractIdAndContractEnterpriseIdEncode = params.get('contractIdAndContractEnterpriseIdEncode') ? params.get('contractIdAndContractEnterpriseIdEncode') : null;
      this.checkSignAnonymousWithCapCha();
      sessionStorage.setItem('tenantId', this.tenantId);
      sessionStorage.setItem('hashKey', this.hashKey);
      if (this.contractIdAndContractEnterpriseIdEncode) {
        sessionStorage.setItem('contractIdAndContractEnterpriseIdEncode', this.contractIdAndContractEnterpriseIdEncode);
      }
      //  this.contractEnterpriseIdEncode = params.get('hashKey');
      // this.tenantIdEncode = params.get('tenantId');
      // this.anonymousSignService.checkStatusContract(this.hashKey, this.tenantId).subscribe((res) => {
      //   if (res.data) {
      //     this.isCheckAccessToContract = res.data !== EnumContractStatus.CANCELLED;
      //   }
      // });
    });
    // kiểm tra trạng thái hđ, nếu đã bị huỷ thì
    this.currentLanguage = localStorage.getItem('__language');
    if (!this.currentLanguage) {
      this.currentLanguage = 'vi';
    }
    // re-saving language.
    localStorage.setItem('__language', this.currentLanguage);
    this.documentService.getApparamInfo({code: 'bypass_captcha'}).subscribe(res => {
      if(res.data && res.data.value == '1') {
          this.skipCaptcha();
      }
    });
    this.checkLoginFail();
    resetRecaptchaValue((rcVal) => {
      this.captcha = rcVal;
      if (rcVal && this.isSignAnonymousWithCapCha) {
        this.loginWithCapCha();
      }
      this.showReCaptchaRequiredErr = false;
    });

    // khi có lỗi trả về từ backend nó sẽ bán ra
    this.notificationService.subscribeErrorService();
  }

  ngOnDestroy() {
    this.notificationService.unsubscribeErrorService();
  }

  skipCaptcha() {
    this.slideCaptcha = "3232";
    this.loginWithCapCha();
  }

  login() {
    if (this.failedLoginCount > this.limitFailedLoginNoReCaptcha && this.slideCaptcha == null) {
      this.showReCaptchaRequiredErr = true;
      return;
    }
    const data = {
      secretKey: this.password,
      hashKey: this.hashKey,
      email: this.username,
      tenantId: this.tenantId,
      slideCaptcha: this.slideCaptcha,
    };
    this.authService.AnonymousLogin(data).pipe(first()).subscribe(
      res => {
        this.checkDisplayMessageError(res.code);
        this.slideCaptcha = null;
        if (res) {
          //chưa xác minh với VT
          if (!res.data.isVerify) {
            localStorage.setItem('enterpriseId', res.data.enterpriseId);
            localStorage.setItem('token', res.data.token);
            localStorage.setItem('tenantId', this.tenantId);
            localStorage.setItem('SignDataValidate', JSON.stringify(res.data));
            localStorage.setItem('customerDTOXMCT', JSON.stringify(res.data.customerDTO));
            localStorage.removeItem('isEnterpriseIdentify')
            //Là hợp đồng thiết yếu và chưa xác minh với doanh nghiệp
            if (res.data.isEssentialContract && !res.data.isEnterpriseIdentify && res.data.enterpriseType == 10000) {
              localStorage.setItem('isEnterpriseIdentify', res.data.isEnterpriseIdentify)
              this.router.navigate([`identification-method/${this.hashKey}/${this.tenantId}`]);
              //Là hợp đồng thiết yếu và đã xác minh với doanh nghiệp
            } else if (res.data.isEssentialContract && res.data.isEnterpriseIdentify && res.data.enterpriseType == 10000) {
              sessionStorage.setItem('tenantId', this.tenantId);
              sessionStorage.setItem('hashKey', this.hashKey);
              localStorage.setItem('SignDataValidate', JSON.stringify(res.data));
              localStorage.setItem('customerDTOXMCT', JSON.stringify(res.data.customerDTO));
              this.router.navigate([`sign-anonymous/${this.hashKey}/${this.tenantId}/detail`]);
            } else {
              this.router.navigate([`kyc-confirm-account-anonymous/${this.hashKey}/${this.tenantId}`]);
            }
          }
          if (res.data.isVerify && res.success) {
            sessionStorage.setItem('tenantId', this.tenantId);
            sessionStorage.setItem('hashKey', this.hashKey);
            localStorage.setItem('SignDataValidate', JSON.stringify(res.data));
            localStorage.setItem('customerDTOXMCT', JSON.stringify(res.data.customerDTO));
            this.router.navigate([`sign-anonymous/${this.hashKey}/${this.tenantId}/detail`]);
          }
        }
      },
      error => {
        this.failedLoginCount = localStorage.getItem('count_login_failed');
        localStorage.removeItem('count_login_failed');
        if (!this.failedLoginCount || this.failedLoginCount == 0) {
          this.failedLoginCount = 1;
        }

        this.invalidLogin = true;
        this.slideCaptcha = null;

        // && this.reCaptcha.reset();
        // document.getElementById('username').focus();

        if (this.failedLoginCount >= this.limitFailedLoginNoReCaptcha) {
          resetRecaptchaStatus(this.currentLanguage);
        }

        // setTimeout(() => {changeRecaptchaLanguage(localStorage.getItem('__language'));}, 100)
      }
    );
  }


  checkLoginFail() {
    this.authService.checkLoginFail().subscribe(rs => {
        this.failedLoginCount = rs.data;
      }
    );
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.dialogRef.closeAll();
    }, 1000);
  }

  isFormValid(): boolean {
    if (this.ngForm.invalid) {
      if (this.failedLoginCount && this.failedLoginCount > this.limitFailedLoginNoReCaptcha) {
        this.showReCaptchaRequiredErr = true;
      }
      return false;
    } else {
      return true;
    }
  }

  onChangeLanguage(languageSelected: string) {
    this.currentLanguage = languageSelected;

    // start waiting.
    this.blockUI.reset();
    this.blockUI.start('');
    this.onCheckBlockUI();

    this.setLanguagelocalStored(languageSelected);
    this.translate.use(this.getLanguagelocalStored());
    this.checkIconLanguage(this.getLanguagelocalStored());
    changeRecaptchaLanguage(languageSelected);
    this.blockUI.stop();
  }

  private onCheckBlockUI() {
    localStorage.setItem('blockUI', '1');
    const timerId = setInterval(() => {
      if (localStorage.getItem('blockUI') == '0') {
        this.blockUI.stop();
        clearInterval(timerId);
        localStorage.removeItem('blockUI');
      }
    }, 1000);
  }

  goBack() {
    this.router.navigate([`/enterprise-login`]);
  }

  @HostListener('submit')
  onFormSubmit() {
    const invalidElements = this.el.nativeElement.querySelectorAll('.mat-input-element.ng-invalid');
    if (invalidElements.length > 0) {
      setTimeout(() => {
        invalidElements[0].focus();
      }, 100);
    }
  }

  checkSignAnonymousWithCapCha() {
    this.isSignAnonymousWithCapCha = !!this.contractIdAndContractEnterpriseIdEncode;
  }

  loginWithCapCha() {
    // localStorage.setItem(this.hashKey, window.location.href)
    const data = {
      secretKey: null,
      hashKey: this.hashKey,
      email: null,
      tenantId: this.tenantId,
      slideCaptcha: this.slideCaptcha
    };
    const isNotAttested = 2
    if (this.contractIdAndContractEnterpriseIdEncode) {
      data['hashLink'] = this.contractIdAndContractEnterpriseIdEncode;
    }
    this.authService.AnonymousLogin(data).pipe(first()).subscribe(
      res => {
        this.checkDisplayMessageError(res.code);
        this.slideCaptcha = null;
        if (res.data) {
          if(res.data.permissionContractShare){
            localStorage.setItem('permissionContractShare', res.data.permissionContractShare)
          }
          if(res.data.contractStatus == 1 && res.data.negotiate){
            res.data.isVerify = true
          }
          this.dataLoginCaptcha = res.data;
          //set token cho chức năng them nguoi phe duyet
          localStorage.setItem('approvalToken', res.data.token);
          localStorage.setItem('actionType', res.data.actionType);
          // Lưu giá trị entTypeAnonymus vào localStorage dùng để check loại CT/KCT (1: CT, 2: KCT)
          localStorage.setItem('entTypeAnonymus', res.data.entType)
          //chưa xác minh với VT
          if (!res.data.isVerify) {
            localStorage.setItem('enterpriseId', res.data.enterpriseId);
            localStorage.setItem('token', res.data.token);
            localStorage.setItem('tenantId', this.tenantId);
            localStorage.setItem('SignDataValidate', JSON.stringify(res.data));
            localStorage.setItem('customerDTOXMCT', JSON.stringify(res.data.customerDTO));
            localStorage.removeItem('isEnterpriseIdentify')
          }
          if (res.data.isVerify && res.success) {
            sessionStorage.setItem('tenantId', this.tenantId);
            sessionStorage.setItem('hashKey', this.hashKey);
          }
          if (res.data.isTwoFactorAuthen) {
            this.anonymousSignService.timeWaitSign.next(res.data.timeWaitSign);
            let account: string = '';
            if (res.data.taxCode) {
              account = res.data.taxCode;
            }
            if (account.length == 0 && res.data.certificateNo) {
              account = res.data.certificateNo;
            }
            if (account.length == 0) {
              this.mode = 'SIGN';
            } else {
              let providerName: string = 'Viettel - MySign';
              this.authService.getCertsCloudCa(account, providerName).subscribe(rs => {
                if (rs && rs.data && rs.data.length > 0) {
                  const certificateDefault = rs.data[0];
                  certificateDefault.cloudCaProviderName = providerName;
                  this.anonymousSignService.selectedCert.next(certificateDefault);
                }
                this.mode = 'SIGN';
              });
            }
            return;
          }
          this.afterVerifyTwoAuthen(true);
        }
      },
      error => {
        this.failedLoginCount = localStorage.getItem('count_login_failed');
        localStorage.removeItem('count_login_failed');
        if (!this.failedLoginCount || this.failedLoginCount == 0) {
          this.failedLoginCount = 1;
        }

        this.invalidLogin = true;
        this.slideCaptcha = null;

        // && this.reCaptcha.reset();
        // document.getElementById('username').focus();

        // if (this.failedLoginCount >= this.limitFailedLoginNoReCaptcha) {
        //   resetRecaptchaStatus(this.currentLanguage);
        // }

        // setTimeout(() => {changeRecaptchaLanguage(localStorage.getItem('__language'));}, 100)
      }
    );
  }

  afterVerifyTwoAuthen(isVerify:boolean) {
    if (isVerify) {
      const data = {
        secretKey: null,
        hashKey: this.hashKey,
        email: null,
        tenantId: this.tenantId,
        slideCaptcha: this.slideCaptcha
      };
      if (this.contractIdAndContractEnterpriseIdEncode) {
        data['hashLink'] = this.contractIdAndContractEnterpriseIdEncode;
      }
      if (!this.dataLoginCaptcha.isVerify) {
        //Là hợp đồng thiết yếu hoặc không chứng thực và chưa xác minh với doanh nghiệp
        if ((this.dataLoginCaptcha.isEssentialContract || this.dataLoginCaptcha.entType === 2) && !this.dataLoginCaptcha.isEnterpriseIdentify && this.dataLoginCaptcha.enterpriseType == 10000) {
          localStorage.setItem('isEnterpriseIdentify', this.dataLoginCaptcha.isEnterpriseIdentify)
          // Nếu là không chứng thực thì chuyển qua màn kyc-customer-identify , nếu ko phải thì như cũ
          if (this.dataLoginCaptcha.entType == 2) {
            if (this.dataLoginCaptcha.isVerifySubject == false) {
              if (this.contractIdAndContractEnterpriseIdEncode) {
                this.router.navigate([`sign-anonymous/${this.hashKey}/${this.tenantId}/${this.contractIdAndContractEnterpriseIdEncode}/detail`]);
              } else {
                this.router.navigate([`sign-anonymous/${this.hashKey}/${this.tenantId}/detail`]);
              }
            } else if (this.contractIdAndContractEnterpriseIdEncode) {
              this.router.navigate([`kyc-customer-identify/${this.hashKey}/${this.tenantId}/${data['hashLink']}`]);
            } else {
              this.router.navigate([`kyc-customer-identify/${this.hashKey}/${this.tenantId}`]);
            }
          } else {
            this.router.navigate([`identification-method/${this.hashKey}/${this.tenantId}`]);
          }
          //Là hợp đồng thiết yếu hoặc không chứng thực và đã xác minh với doanh nghiệp
        } else if ((this.dataLoginCaptcha.isEssentialContract || this.dataLoginCaptcha.entType === 2) && this.dataLoginCaptcha.isEnterpriseIdentify && this.dataLoginCaptcha.enterpriseType == 10000) {
          sessionStorage.setItem('tenantId', this.tenantId);
          sessionStorage.setItem('hashKey', this.hashKey);
          if (this.contractIdAndContractEnterpriseIdEncode) {
            sessionStorage.setItem('contractIdAndContractEnterpriseIdEncode', this.contractIdAndContractEnterpriseIdEncode);
          }
          localStorage.setItem('SignDataValidate', JSON.stringify(this.dataLoginCaptcha));
          localStorage.setItem('customerDTOXMCT', JSON.stringify(this.dataLoginCaptcha.customerDTO));
          this.router.navigate([
            'sign-anonymous',
            this.hashKey,
            this.tenantId,
            this.contractIdAndContractEnterpriseIdEncode,
            'detail'
          ]);
        } else {
          this.router.navigate([
            'kyc-confirm-account-anonymous',
            this.hashKey,
            this.tenantId,
            this.contractIdAndContractEnterpriseIdEncode
          ]);
        }
      } else {
        if (this.contractIdAndContractEnterpriseIdEncode) {
          sessionStorage.setItem('contractIdAndContractEnterpriseIdEncode', this.contractIdAndContractEnterpriseIdEncode);
        }
        localStorage.setItem('SignDataValidate', JSON.stringify(this.dataLoginCaptcha));
        localStorage.setItem('customerDTOXMCT', JSON.stringify(this.dataLoginCaptcha.customerDTO));
        this.router.navigate([
          'sign-anonymous',
          this.hashKey,
          this.tenantId,
          this.contractIdAndContractEnterpriseIdEncode,
          'detail'
        ]);

      }
    }
  }

  resolvedCaptCha(captCha?: any) {
    localStorage.removeItem(this.hashKey);
    this.slideCaptcha = captCha;
    if (captCha && this.isSignAnonymousWithCapCha) {
      this.loginWithCapCha();
    }
  }

  checkDisplayMessageError(code) {
    if (code && code === ErrorCode.NoAccessToContracts) {
      //this.router.navigate([`/error`]);
      window.location.href = 'error';
    } else if (code && code === ErrorCode.ContractExpireTime) {
      //this.router.navigate([`/expire`]);
      window.location.href = 'expire';
    }
  }
  onChangeAction(data:any) {
    if (data) {
      this.mode = data;
    }
  }
  changeMode(data:any) {
    if (data) {
      this.mode = data;
    }
  }

  getCurrentNameLanguage(): string{
    switch(this.currentLanguage){
      case 'vi':
        return 'Tiếng Việt';
      case 'en':
        return 'English';
      case 'zh':
        return '中国人';
      case 'es':
        return 'Español';
      default:
        return 'Tiếng Việt'
    }
  }
  isOpen: boolean = false;
}
